import { createContext, useCallback, useState, useSyncExternalStore } from "react"
import API from "services/api"
import _ from "lodash"
import moment from "moment"
import toast from "react-hot-toast"

export const DashboardContext = createContext({})

const DashboardProvider = (props) => {
	const [countToday, setCountToday] = useState(null)
	const [countDrafted, setCountDrafted] = useState(null)
	const [countStatus, setCountStatus] = useState([])
	const [countSubmit, setCountSubmit] = useState(null)
	const [countActive, setCountActive] = useState(null)

	const [marklist, setMarkList] = useState([])

	const [listFiling, setListFiling] = useState(null)

	const [draftedlist, setDraftedList] = useState([])
	const [weeklyStatus, setWeeklyStatus] = useState([])
	const [weeklySub, setWeeklysub] = useState([])

	const [countbyClass, setCountByClass] = useState(null)

	const getCountToday = (params) => {
		API.getCountToday({ params })
			.then((res) => {
				const { data } = res
				setCountToday(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getCountDrafted = (params) => {
		API.getCountDrafted({ params })
			.then((res) => {
				const { data } = res
				setCountDrafted(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getWeeklyCount = (params) => {
		API.getWeeklyCount({ params })
			.then((res) => {
				const { data } = res
				setWeeklyStatus(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getWeeklybySub = (params) => {
		API.getWeeklybySub({ params })
			.then((res) => {
				const { data } = res
				setWeeklysub(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getCountByStatus = (params) => {
		API.getCountByStatus({ params })
			.then((res) => {
				const { data } = res
				setCountStatus(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getCountbySubmitted = (params) => {
		API.getCountbySubmitted({ params })
			.then((res) => {
				const { data } = res
				setCountSubmit(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getCountActive = (params) => {
		API.getCountActive({ params })
			.then((res) => {
				const { data } = res
				setCountActive(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getFilingToday = (params) => {
		API.getFilingToday({ params })
			.then((res) => {
				const { data } = res
				setMarkList(data)
			})
			.catch((err) => toast.error("context error!", err))
	}

	const getDashboardList = (params) => {
		API.getDashboardList({ params })
			.then((res) => {
				const { data } = res
				setListFiling(data)
			})
			.catch((err) => toast.error("context error!", err))
	}

	// const getDrafted = (params) => {
	// 	API.getDrafted({ params })
	// 		.then((res) => {
	// 			const { data } = res
	// 			setDraftedList(data)
	// 		})
	// 		.catch((err) => toast.error("something wrong!", err))
	// }

	const getCountbyClass = (params) => {
		API.getCountbyClass({ params })
			.then((res) => {
				const { data } = res
				setCountByClass(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	return (
		<DashboardContext.Provider
			value={{
				countToday,
				getCountToday,

				countStatus,
				getCountByStatus,

				countSubmit,
				getCountbySubmitted,

				marklist,

				// draftedlist,
				// getDrafted,

				weeklyStatus,
				getWeeklyCount,

				weeklySub,
				getWeeklybySub,

				countDrafted,
				getCountDrafted,

				countbyClass,
				getCountbyClass,

				countActive,
				getCountActive,

				listFiling,
				getDashboardList
			}}
			{...props}
		/>
	)
}

export default DashboardProvider
